var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoisture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "moisture",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.602,
    height: 52.561,
    viewBox: "0 0 66.602 52.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #moisture .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #moisture .cls-2 {\n        fill: #00c4ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.282,19.528c.025-.3.041-.6.041-.9A10.284,10.284,0,0,0,50.051,8.356a10.146,10.146,0,0,0-5.4,1.539,12.241,12.241,0,0,0-24.1.391,9.876,9.876,0,0,0-3.322-.578A10.281,10.281,0,0,0,6.965,19.978c0,.122,0,.243.013.372C4.109,21.131,0,22.791,0,28.654c0,4.358,3.627,8.1,8.563,8.334l1.511-2.331c-.179,0-.384.008-.524.016l-.367.009c-3.743,0-6.79-2.706-6.791-6.031,0-3.961,2.155-5.246,6.152-6.237l.9-.343.026-.907-.045-.487a5.284,5.284,0,0,1-.068-.7,7.89,7.89,0,0,1,7.88-7.879,7.758,7.758,0,0,1,3.827,1.036l1.814,1.016-.037-2.08a9.609,9.609,0,0,1,9.31-9.664l.517-.015A9.623,9.623,0,0,1,42.416,11.4a7.581,7.581,0,0,1-.025.823L42.283,15.3l2.159-2.192a7.81,7.81,0,0,1,5.61-2.36A7.869,7.869,0,0,1,57.773,20.2l-.241,1.2,1.2.211a6.358,6.358,0,0,1,5.468,5.8,7.379,7.379,0,0,1-4.859,7.114l.8,2.225a9.662,9.662,0,0,0,6.451-9.455,8.635,8.635,0,0,0-6.308-7.764",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.8,195.985h0c-3.968-5.31-3.7-14.46-3.89-11.529-.5,7.647-3.511,11.529-3.511,11.529a3.344,3.344,0,0,0-.393,1.566,4.117,4.117,0,0,0,8.186,0,3.329,3.329,0,0,0-.4-1.566",
    transform: "translate(-59.434 -149.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.843,163.943h0c-3.463-4.639-3.235-12.626-3.4-10.069-.435,6.68-3.062,10.069-3.062,10.069a2.916,2.916,0,0,0-.348,1.366,3.6,3.6,0,0,0,7.15,0,2.948,2.948,0,0,0-.346-1.366",
    transform: "translate(-118.887 -124.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.831,217.886h0c-3.168-4.244-2.954-11.556-3.11-9.214-.392,6.11-2.8,9.214-2.8,9.214a2.678,2.678,0,0,0-.314,1.252,3.291,3.291,0,0,0,6.543,0,2.68,2.68,0,0,0-.316-1.252",
    transform: "translate(-164.122 -169.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.081,166.536h0c-1.992-2.671-1.859-7.271-1.954-5.8a11.194,11.194,0,0,1-1.764,5.8,1.626,1.626,0,0,0-.2.787,2.073,2.073,0,0,0,4.12,0,1.642,1.642,0,0,0-.2-.787",
    transform: "translate(-191.439 -130.622)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoisture);
export default __webpack_public_path__ + "static/media/moisture.73200094bf682030de3039408fee2177.svg";
export { ForwardRef as ReactComponent };